import { lazy } from "react";
// project import
import Loadable from "components/Loadable";
// import { RequireAuthorizedAccess } from "routes/guards/RequireAuthorizedAccess";
import AddDataStandardForm from "pages/basic/crud/AddDataStandardForm";
// import EditDataStandardForm from "pages/basic/crud/EditDataStandardForm";
// import AdminManageData from "pages/admin/admin/AdminManageData";
// import AdminService from "services/administration/DataEntryService";
// import { DataEntry } from "models/nostradamus/administration/DataEntry";
import SurveyConfig from "pages/nostradamus/moral-psychological-support/survey/config/forms/SurveyConfig";
import EditDataForm from "pages/nostradamus/administration/data-entry/components/EditDataForm";
// import Permissions from "constants/Permissions";
import SurveyService from "services/nostradamus/moral-psychological-support/SurveyService";
import { Survey } from "models/nostradamus/moral-psychological-support/Survey";
import SurveyResultForm from "pages/nostradamus/moral-psychological-support/survey/components/SurveyResultForm ";

// ==============================|| ROUTES ITEMS - MORAL PSYCHOLOGICAL SUPPORT||============================== //

//Survey
const SurveyPage = Loadable(
    lazy(() => import("pages/nostradamus/moral-psychological-support/survey/SurveyPage"))
);

// Setting
const Settings = Loadable(
    lazy(() => import("pages/nostradamus/administration/setting/SettingPage"))
);

const moral_psychological_support = {
    path: "moral-psychological-support",
    children: [
        {
            path: "survey",
            element: (
                // <RequireAuthorizedAccess permissions={Permissions.MoralPsychologicalSupportSection.Survey}>
                <SurveyPage />
                // </RequireAuthorizedAccess>
            ),
            children: [
                {
                    index: true,
                },
                {
                    path: "create",
                    element: (
                        <AddDataStandardForm
                            navigateTo={"/moral-psychological-support/survey"}
                            service={SurveyService}
                            pageTitle="Add survey"
                            config={SurveyConfig}
                            entity={Survey}
                            slice={"survey"}
                        />
                    ),
                },
                {
                    path: "edit/:id",
                    element: (
                        <EditDataForm
                            navigateTo={"/moral-psychological-support/survey"}
                            service={SurveyService}
                            pageTitle="Edit survey"
                            config={SurveyConfig}
                            entity={Survey}
                            slice={"survey"}
                        />
                    ),
                },
                {
                    path: "view-result/:id",
                    element: (
                        <SurveyResultForm
                            navigateTo={"/moral-psychological-support/survey"}
                            service={SurveyService}
                            pageTitle="Survey results"
                            config={SurveyConfig}
                            entity={Survey}
                            slice={"survey"}
                        />
                    ),
                },
            ],
        },
        {
            path: "setting",
            element: (
                // <RequireAuthorizedAccess
                //     permissions={Permissions.Admin.Roles}
                // >
                <Settings />
                // </RequireAuthorizedAccess>
            ),
        },
    ],
};

export default moral_psychological_support;
